import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=2117888e"
import script from "./AlertForm.vue?vue&type=script&lang=js"
export * from "./AlertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports